import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing the tableApprovalLogsView.
 * @extends JetView
 */
export default class tableApprovalLogsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [{
                id: "preloader", // ID for the preloader
                cols: [
                    {
                        view: "datatable", // DataTable component
                        css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                        id: "datatable", // ID for the main data table
                        select: true, // Enable row selection
                        scrollY: true, // Enable vertical scrolling
                        columns: [
                            {
                                id: "detailTittle", header: "", width: 60, height: 25, tooltip: "Detalles", // Column for detail icons
                                template: function (obj) { // Template function for rendering icons based on conditions
                                    if (obj.TypeVerification == '1') {
                                        if (obj.StateId != '0') {
                                            return "<span class='webix_icon wxi-close details'></span><span class='webix_icon wxi-close info'></span>";
                                        }
                                        return "<span class='webix_icon wxi-close info'></span>";
                                    } else {
                                        if (obj.StateId != '0') {
                                            return "<span class='webix_icon wxi-close details'></span>";
                                        }
                                    }
                                    return "";
                                }
                            },
                            {
                                id: "Country", // Column for country representation
                                header: _("País"), // Localized header
                                hidden: !devConfig.getPermAction("filterByCountry", "Add"), // Conditional visibility based on permissions
                                css: "prm-filterByCountry", // CSS class for styling
                                width: 50, // Column width
                                sort: "int", // Sorting type
                                template: function (obj) { // Template function for rendering country flags
                                    return "<i class='flags " + obj.Country + "'></i>";
                                }
                            },
                            {id: "Id", header: "Id", width: 100, sort: "int"}, // Column for ID
                            {
                                id: "Time", header: _("Fecha"), // Column for date
                                fillspace: 0, minWidth: 0, width: 200, // Column dimensions
                                sort: "text", format: dateFormat // Sorting and formatting
                            },
                            {id: "UserName", header: _("ID Usuario"), width: 200, sort: "int"}, // Column for user ID
                            {id: "UserNameApproval", header: _("Usuario Aprueba"), width: 200, sort: "int"}, // Column for approving user
                            {
                                id: "StateId", header: _("Estado"), width: 110, sort: "int", editor: "combo", // Column for state with combo editor
                                options: [ // Options for state selection
                                    {id: "0", value: _("")},
                                    {id: "3", value: _("Pendiente")},
                                    {id: "1", value: _("Aprobada")},
                                    {id: "2", value: _("Rechazada")},
                                    {id: "NE", value: _("No Ejecutado")},
                                    {id: "I", value: _("Iniciada")}
                                ]
                            },
                            {
                                hidden: !devConfig.getPermAction('viewColumnTypeVerification', 'Add'), // Conditional visibility based on permissions
                                id: "TypeVerification", 
                                header: _("Origen"), 
                                width: 110, 
                                sort: "int", 
                                editor: "combo", 
                                options: [ // Options for type verification
                                    {id: "0", value: _("Manual")},
                                    {id: "1", value: _("Proveedor")}
                                ]
                            },
                            {
                                hidden: !devConfig.getPermAction('viewColumnType', 'Add'), // Conditional visibility based on permissions
                                id: "Type", 
                                header: _("Tipo Reporte"), 
                                width: 200, 
                                sort: "int", 
                                editor: "combo", 
                                options: [ // Options for report type
                                    {id: "0", value: _("Verificación de datos")},
                                    {id: "1", value: _("Actualización de datos")}
                                ]
                            },
                            {id: "UserGenerated", header: _("Usuario Genera"), width: 110, sort: "int"}, // Column for user who generated the entry
                            {id: "Note", header: _("Nota"), width: 250, sort: "int"}, // Column for notes
                            {
                                hidden: !devConfig.getPermAction('viewColumnVerificationProvider', 'Add'), // Conditional visibility based on permissions
                                id: "VerificationProvider", 
                                header: _("Proveedor de verificación"), 
                                width: 200, 
                                sort: "int" 
                            }
                        ],
                        onClick: { // Event handlers for click events on the datatable
                            "details": function (euv, id) { // Handler for details icon click
                                var item = this.getItem(id); // Get the clicked item
                                item.StateId = "0"; // Update state ID
                                webix.ui({ // Create a popup window for user verification
                                    view: "window", css: "cssPopupIframe",
                                    id: "popupIframe",
                                    head: {
                                        view: "toolbar",
                                        cols: [
                                            {
                                                view: "label",
                                                label: _("Verificación de usuario"), // Localized label
                                                align: "center"
                                            },
                                            {
                                                view: "icon",
                                                icon: "wxi-close",
                                                id: "button-close-modal",
                                                click: function () { // Close button click handler
                                                    this.getTopParentView().hide();
                                                }
                                            }
                                        ]
                                    },
                                    move: true,
                                    position: "center",
                                    modal: true,
                                    body: {
                                        view: "iframe", // Iframe for displaying user verification
                                        id: "frame-body",
                                        src: "/#!/top/usersVerificationManagement?user=" + item.UserName + "&id=" + item.Id + "/security.userVerification2.information"
                                    }
                                }).show(); // Show the popup
                                $$("popupIframe").setPosition(15, 15); // Set position of the popup
                                $$("popupIframe").$setSize(($(window).width()) - 30, $(window).height() - 30); // Set size of the popup
                            },
                            "info": function (euv, id) { // Handler for info icon click
                                var item = this.getItem(id); // Get the clicked item
                                var vthis = this; // Reference to the current context
                                var params = {
                                    Id: item.Id // Parameters for the AJAX request
                                };
                                webix.ajax().headers({ // AJAX request to get decision details
                                    "Content-type": "application/json"
                                }).post(devConfig.geturlApi() + "UserManagement/GetDecisionDetail", params, {
                                    error: function (text, data, XmlHttpRequest) { // Error handler
                                        vthis.getTopParentView().hide(); // Hide the popup on error
                                    },
                                    success: function (text, data, XmlHttpRequest) { // Success handler
                                        var data = JSON.parse(text); // Parse the response data
                                        if (!data.HasError) { // Check for errors in the response
                                            webix.ui({ // Create a popup window for displaying details
                                                view: "window",
                                                move: true,
                                                css: "json",
                                                width: (screen.width < 500) ? 350 : 500,
                                                height: (screen.width < 500) ? 350 : 500,
                                                head: {
                                                    view: "toolbar",
                                                    cols: [
                                                        {view: "label", label: _("Detalles"), align: "center"}, // Localized label for details
                                                        {
                                                            view: "icon", icon: "wxi-close", click: function () { // Close button click handler
                                                                this.getTopParentView().hide();
                                                            }
                                                        }
                                                    ]
                                                },
                                                modal: true,
                                                position: "center",
                                                body: {
                                                    rows: [
                                                        {
                                                            template: function (obj) { // Template for displaying JSON data
                                                                return "<div id='result-after' ><pre>" + JSON.stringify(data.Data, undefined, 2) + "</pre></div>";
                                                            }
                                                        }
                                                    ]
                                                }
                                            }).show(); // Show the details popup
                                        }
                                    }
                                });
                            }
                        },
                        tooltip: true, // Enable tooltips
                        math: true, // Enable math calculations
                        loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                        pager: "pagerA" // Pager ID for pagination
                    },
                    {
                        view: "datatable", // Second datatable for summary
                        css: "webix_header_border webix_data_border webix_footer_border",
                        id: "datatable2", // ID for the second datatable
                        hidden: true, // Initially hidden
                        select: true, // Enable row selection
                        scrollY: true, // Enable vertical scrolling
                        columns: [
                            {id: "Initiated", header: _("Iniciadas"), width: 250, sort: "int"}, // Column for initiated count
                            {id: "Pending", header: _("Pendientes"), width: 250, sort: "int"}, // Column for pending count
                            {id: "Approved", header: _("Aprobadas"), width: 250, sort: "int"}, // Column for approved count
                            {id: "Rejected", header: _("Rechazadas"), width: 250, sort: "int"}, // Column for rejected count
                            {id: "NotExecuted", header: _("No Ejecutadas"), width: 250, sort: "int"}, // Column for not executed count
                        ],
                        tooltip: true, // Enable tooltips
                        math: true, // Enable math calculations
                        loadahead: 0, // Load ahead configuration
                        datafetch: devConfig.getDefaultDataFetch() // Default data fetch configuration
                    }
                ]
            }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const _ = this.app.getService("locale")._; // Localization service
        var url = devConfig.geturlApi() + "UserManagement/GetUserLogs2"; // API endpoint for user logs
        var vthis = this; // Reference to the current context
        var filter = ""; // Filter string for API requests
        this.on(this.app, "requests:filter", filterData => { // Event listener for filter requests
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ""; // Initialize filter string
            for (var i = 0; i < object.length; i++) { // Iterate over filter entries
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) { // Check for non-object and non-empty values
                    if (object[i][0] == "Datepicker") { // Handle date range filter
                        var date = object[i][1].split(" - ");
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != "Date") {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == "Date") { // Handle single date filter
                                var date = object[i][1].replace(" 00:00:00", "");
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) { // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) { // Iterate over object entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") { // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === "end") { // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (filterData.Overall == 1) { // Check overall filter condition
                $$("datatable").hide(); // Hide main datatable
                $$("datatable2").show(); // Show summary datatable
                grid = $$('datatable2'); // Set grid to summary datatable
                grid.clearAll(); // Clear existing data
                grid.load(url + '?start=0&count=1' + string1); // Load data with filters
            } else if (filterData.Overall == 0) { // Check overall filter condition
                $$("datatable2").hide(); // Hide summary datatable
                $$("datatable").show(); // Show main datatable
                grid = $$('datatable'); // Set grid to main datatable
                grid.clearAll(); // Clear existing data
                grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            }
            filter = string1; // Update filter string
        });
    }
}

/**
 * Custom UI component for displaying an image label.
 */
webix.protoUI({
    name: "imageLabel", // Name of the custom UI component
    setValue: function (value) { // Function to set the image source
        this.setHTML("<img style='width:100%;height: 100%;' src='" + value + "'>"); // Set HTML for image display
    }
}, webix.ui.label);

// FILE DOCUMENTED
